/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import RodoContent from '../../components/RodoContent';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import Select from 'react-select';
import agentConfig from './agent';
import loadingData from './loading';

import v from './validators';
import u from './utils';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const zalacznikDict = {
  rodzaj_mapy: {
    label: 'Rodzaj mapy (np. topograficzna)',
    editable: true,
  },
  skala_mapy: {
    label: 'Skala mapy',
    editable: true,
  },
  kolor: {
    label: 'Kolor oznaczenia budynku',
    editable: true,
  },
};

const mpzpOwnerDict = {
  CompanyName: {
    label: 'Nazwa osoby prawnej lub jednostki organizacyjnej',
    editable: true,
  },
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy',
    editable: true,
  },
  AddressPhone: {
    label: 'Telefon',
    editable: true,
  },
  AddressEmail: {
    label: 'Email',
    editable: true,
  },
};

const UstytuowanieBudynku = [
  { label: 'Budynek naziemny', value: 'naziemny', target: { name: 'ustytuowanieBudynku', value: 'naziemny' } },
  { label: 'Budynek podziemny', value: 'podziemny', target: { name: 'ustytuowanieBudynku', value: 'podziemny' } }
]

const StatusBudynku = [
  { value: 'istniejacy', label: 'Budynek istniejący', target: { name: 'statusBudynku', value: 'istniejacy' } },
  { value: 'wtrakcie', label: 'Budynek w trakcie budowy', target: { name: 'statusBudynku', value: 'wtrakcie' } },
  { value: 'prognozowany', label: 'Budynek prognozowany', target: { name: 'statusBudynku', value: 'prognozowany' } }

]

class UstalenieNumeruPorzadkowego extends React.Component {
  state = {
    mpzpOwner: {
      CompanyName: null,
      AddressCity: null,
      AddressStreet: null,
      AddressNumber: null,
      AddressFlat: null,
      AddressZipCode: null,
      AddressPhone: null,
      AddressEmail: null,
    },
    zalacznik: {
      rodzaj_mapy: null,
      skala_mapy: null,
      kolor: null,
    },
    dzialka: {
      ulica: null,
      miejscowosc: null,
      ustytuowanieBudynku: null,
      statusBudynku: null
    },
    info: {
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    acceptRODO: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    rodzaj_mapy: [v.NotNull],
    skala_mapy: [v.NotNull],
    kolor: [v.NotNull],
    miejscowosc: [v.NotNull],
    ustytuowanieBudynku: [v.NotSelected],
    statusBudynku: [v.NotSelected],
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });
  changeAcceptRODO = () => this.setState({ acceptRODO: !this.state.acceptRODO });

  render_info = (group, key) => (
    <span>
      <b>{this.state[group][key] ? this.state[group][key] : this.elseString}</b>
    </span>
  );

  getInformationAttachment = () => (
    <p style={{ textAlign: 'justify' }}>
      Kopia mapy {this.render_info('zalacznik', 'rodzaj_mapy')} w skali {this.render_info('zalacznik', 'skala_mapy')},  na której kolorem {this.render_info('zalacznik', 'kolor')} wyróżniono budynek będący przedmiotem wniosku.
    </p>
  )

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  getInputWithError = (description, group, field) => (
    <div style={{ textAlign: 'justify' }}>
      {description}
      <input
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getTextAreaWithError = (description, group, field) => (
    <p style={{ textAlign: 'justify' }}>
      {description}
      <textarea
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        rows={10}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </p>
  )

  onChange = (e, group) => {

    const name = e.target.name;

    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ["mpzpOwner", "dzialka"];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      mpzpOwner: {
        CompanyName: "xDDDDDDDDD",
        AddressCity: "Warszawa",
        AddressStreet: "KEN",
        AddressNumber: "85",
        AddressFlat: "87",
        AddressZipCode: "02-797",
        AddressPhone: "888 231 213",
        AddressEmail: "pl@giap.pl"
      },
      info: {
        zmiana_z: "qwe",
        przeznaczenie: "hehe",
        uzasadnienie: "takie tam",
      },
      dzialka: {
        ulica: "Piekna",
        miejscowosc: "Radymno"
      }
    });
  };

  validateAttachmentsContent = () => {
    for (const attachment of this.state.attachments) {
      if (attachment.name.length < 1) return true;
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }
    //Biała Rawska
    if (this.props.district === "1013024" && !this.state.acceptRODO) {
      this.setState({
        errorText: 'Proszę o akceptację wymaganych pól. ',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          zalacznik: { ...this.state.zalacznik },
          info: { ...this.state.info },
          mpzpOwner: { ...this.state.mpzpOwner },
          dzialka: { ...this.state.dzialka },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel
          title={'1. Teren'}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden
            z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li>
                {' '}
                Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer
                działki. W celu dodania kolejnej działki należy powtórzyć czynność.
              </li>
              <li>
                Wskazać działkę w oknie mapy wykorzystując przycisk{' '}
                <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest
                przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.
              </li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku{' '}
            <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ color: 'red' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <DecisionContainer
          title={'2. Osoba prawna lub jednostka organizacyjna'}
          data={this.state.mpzpOwner}
          errors={this.state.errors}
          formDict={mpzpOwnerDict}
          onChange={e => this.onChange(e, 'mpzpOwner')}
        />


        <GrayPanel title={'3. Informacje o budynku'}>
          <div className="row mobile-row" style={rowStyle}>
            <div className="col-sm-2" />
            <div className="col-sm-2">
              <label htmlFor="ulica" style={labelStyle}>Ulica</label>
            </div>
            <div className="col-sm-6">
              <input
                type="text"
                name="ulica"
                className="form-control"
                value={this.state.dzialka.ulica}
                onChange={(e) => this.onChange(e, 'dzialka')} />
            </div>
            <div className="col-sm-2" />
          </div>

          <div className="row mobile-row" style={rowStyle}>
            <div className="col-sm-2" />
            <div className="col-sm-2">
              <label htmlFor="ulica" style={labelStyle}>Miejscowość</label>
            </div>
            <div className="col-sm-6">
              <input
                type="text"
                name="miejscowosc"
                className="form-control"
                value={this.state.dzialka.miejscowosc}
                onChange={(e) => this.onChange(e, 'dzialka')} />
            </div>
            <div className="col-sm-2" />
          </div>

          <div className="row mobile-row" style={rowStyle}>
            <div className="col-sm-2" />
            <div className="col-sm-2">
              <label htmlFor="ulica" style={labelStyle}>Usytuowanie budynku</label>
            </div>
            <div className="col-sm-6">
              <Select
                placeholder="Wybierz z listy..."
                options={UstytuowanieBudynku}
                value={this.state.dzialka.ustytuowanieBudynku}
                onChange={(e) => this.onChange(e, 'dzialka')} 
                style={{
                  borderColor:
                    Object.keys(this.state.errors).indexOf("ustytuowanieBudynku") > -1 &&
                      this.state.errors["ustytuowanieBudynku"] !== null &&
                      this.state.errors["ustytuowanieBudynku"].length > 0
                      ? 'red'
                      : '#ccc',
                }}
              />
              {Object.keys(this.state.errors).indexOf("ustytuowanieBudynku") > -1 &&
              this.state.errors["ustytuowanieBudynku"] !== null &&
              this.state.errors["ustytuowanieBudynku"].length > 0 ?
              <span key={Object.keys(this.state.errors).indexOf("ustytuowanieBudynku")} style={{
                color: 'red',
                fontSize: '10px'
              }}>
                {this.state.errors["ustytuowanieBudynku"]}
              </span> : null}
            </div>
            <div className="col-sm-2" />
          </div>

          <div className="row mobile-row" style={rowStyle}>
            <div className="col-sm-2" />
            <div className="col-sm-2">
              <label htmlFor="ulica" style={labelStyle}>Status budynku</label>
            </div>
            <div className="col-sm-6">
              <Select
                placeholder="Wybierz z listy..."
                options={StatusBudynku}
                value={this.state.dzialka.statusBudynku}
                onChange={(e) => this.onChange(e, 'dzialka')} 
                style={{
                  borderColor:
                    Object.keys(this.state.errors).indexOf("statusBudynku") > -1 &&
                      this.state.errors["statusBudynku"] !== null &&
                      this.state.errors["statusBudynku"].length > 0
                      ? 'red'
                      : '#ccc',
                }}
              />
              {Object.keys(this.state.errors).indexOf("statusBudynku") > -1 &&
              this.state.errors["statusBudynku"] !== null &&
              this.state.errors["statusBudynku"].length > 0 ?
              <span key={Object.keys(this.state.errors).indexOf("statusBudynku")} style={{
                color: 'red',
                fontSize: '10px'
              }}>
                {this.state.errors["statusBudynku"]}
              </span> : null}
            </div>
            <div className="col-sm-2" />
          </div>
          {(this.props.district === "1013024") ?
                  <div className="help-desc">
                    <br></br>
                    <div className={s.subtitle}>
                      <input
                        name="isDefault"
                        type="checkbox"
                        value={this.state.acceptRODO}
                        onChange={this.changeAcceptRODO}
                      /><gwiazda style={{ color: 'red' }}>*</gwiazda>Zgoda na przetwarzanie danych
                      <u.RODOBialaRawska/>
                  </div>
                    <div className={s.subtitle} style={{ color: 'red' }}>
                      * - Pole obowiązkowe
                  </div></div>
                  : null}
        </GrayPanel>

        <DecisionContainer
          title={'4. Informacje o załączniku'}
          data={this.state.zalacznik}
          explain_text={() => this.getInformationAttachment()}
          errors={this.state.errors}
          formDict={zalacznikDict}
          onChange={e => this.onChange(e, 'zalacznik')}
        />

        <RodoContent prefix={this.props.prefix} />

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} />


        {/* <GrayPanel title={"Informacja dla wnioskodawcy"}>
          <div className="row">
            <div className="col-sm-12">
              <p><b>Do niniejszego wniosku należy dołączyć załącznik</b></p>
              <p>1. Załącznikiem może być kopia mapy: zasadniczej, ewidencyjnej, z projektem podziału, topograficznej w skalnie nie mniejszej niż 1:10 000 lub kopia projektu zagospodarowania działki lub terenu.</p>
            </div>
          </div>
        </GrayPanel> */}

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

UstalenieNumeruPorzadkowego.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(UstalenieNumeruPorzadkowego),
);



// WEBPACK FOOTER //
// src/routes/eservices/UstalenieNumeruPorzadkowego.js